import * as React from "react"
import {useEffect} from "react"
import {object, string} from "yup";
import {TextFieldSeeker} from "@ui-seeker/core";
import {useValidatorSeeker} from "@ui-seeker/app";

import {useMatchersSkusForm} from "../../@hooks";
import {matcherSKUDrawerError} from "../../@signals";


export default function MatchersSKUsDrawerImageURL() {
	const { localValue, handleChange } = useMatchersSkusForm('thumbnail')
	const { errors } = useValidatorSeeker({
		imageURL: localValue
	}, object({
		imageURL: string().url('Must be a valid URL').required('Image URL is mandatory')
	}))

	useEffect(() => {
		matcherSKUDrawerError.value = {
			...matcherSKUDrawerError.value,
			thumbnail: errors?.imageURL
		}
	}, [errors?.imageURL]);

    return <TextFieldSeeker
		fullWidth
		label="SKU URL"
		placeholder="Please enter the SKU URL"
		value={localValue || ''}
		onChange={e => handleChange(e.target.value)}
		error={errors?.imageURL}
	/>
}
